module.exports = __webpack_public_path__ + "img/4_brendan_h.42e866ea.png";